import * as React from 'react';

import Star16 from './Star16';

export const star16 = () => <Star16 />;

export default {
    title: 'Icon|Line|Star16',
    component: Star16,
    parameters: {
        notes: "`import Star16 from 'box-ui-elements/es/icon/line/Star16';`",
    },
};
